// @ vendors
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
// @ actions
const accountDebitsEditActions = require('actions/accountDebitsEdit');
// @ commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const InactiveAccountsError = require('components/commons/inactiveAccountsError/inactiveAccountsError');
// @ components
import OKLayout from 'components/commons/OKLayout/OKLayout';
const AccountDebitsEditStep1 = require('components/accounts/accountDebits/accountDebitsEditSteps/accountDebitsEditStep1/accountDebitsEditStep1');
const AccountDebitsEditStep2 = require('components/accounts/accountDebits/accountDebitsEditSteps/accountDebitsEditStep2/accountDebitsEditStep2');
const AccountDebitsEditSuccessStep = require('components/accounts/accountDebits/accountDebitsEditSteps/accountDebitsEditSuccessStep/accountDebitsEditSuccessStep');
const AccountDebitsEditErrorStep = require('components/accounts/accountDebits/accountDebitsEditSteps/accountDebitsEditErrorStep/accountDebitsEditErrorStep');
// @ utilities
const { formatAmountObject } = require('utilities/currencyHelper');
const { toCamelCase, getLastNChars } = require('utilities/stringHelper');
const AccessHelper = require('utilities/accessHelper');
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');
// @ constants
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER
} = require('constants/index');
const { accountConstants } = require('utilities/accessHelperConditions/accounts');
const { BRING_DIRECT_DEBITS, WEB_INACTIVE_ACCOUNT_ENABLED } = require('constants/flagBasedFeatures');
import { NEGATIVE } from 'constants/layout';

class AccountDebitsEditView extends React.Component {
    constructor(props) {
        super(props);

        if (!props.immFlagBasedFeatures.get(BRING_DIRECT_DEBITS)) {
            props.history.push(`/myprofile/accounts/${props.match.params.accountId}/debits`);
        }

        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
    }

    componentDidMount() {
        const { history, immAccounts, match: { params: { accountId } } } = this.props;

        AccessHelper.allowAccess(accountConstants.ACCOUNTS_DEBITS_EDIT_VIEW, { immAccounts, accountId }, history);

        this.props.setOriginAccountId(accountId);
        this.props.resetStep(1);
    }

    componentWillUnmount() {
        this.props.reset();
    }

    getOperationParams() {
        const {
            immAccounts,
            immAccountDebitsEdit,
            match: { params: { accountId } }
        } = this.props;

        const operationParams = {};
        const immSteps = immAccountDebitsEdit.get('steps');
        const firstStep = immSteps.get(0);
        const newAccountId = firstStep.get('newAccount') || '';
        const immNewAccount = immAccounts.getIn(['byId', newAccountId]);

        if (immNewAccount) {
            const immAccount = immAccounts.get('byId').get(accountId);
            const immIbanComplex = immAccount.get('ibanComplex');
            const codbban = immIbanComplex.get('codbban');
            const controldigit = immIbanComplex.get('digitodecontrol');
            const country = immIbanComplex.get('pais');
            const contractNumber = immNewAccount.get('newContractNumber');
            const product = immNewAccount.get('newProduct');

            operationParams.originAccount = `${country}${controldigit}${codbban}`;
            operationParams.destinationAccount = `${API_ENTERPRISE_NUMBER}${API_CENTER}${product}${contractNumber}`;
        }

        return operationParams;
    }

    buildSuccessful() {
        const { match: { params: { accountId } }, immAccounts, immAccountDebitsEdit } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);
        const immSteps = immAccountDebitsEdit.get('steps');
        const immNewAccount = immAccounts.get('byId').get(immSteps.get(0).get('newAccount'));
        const alias = immAccount.get('alias');
        const newAlias = (immNewAccount) ? immNewAccount.get('alias') : '';

        return (
            <div className="row no-gutter">
                <div className="col-xs-offset-2 col-xs-8">
                    <AccountDebitsEditSuccessStep
                        accountId={accountId}
                        alias={alias}
                        newAlias={newAlias}
                    />
                </div>
            </div>
        );
    }

    buildError() {
        const { match: { params: { accountId } } } = this.props;
        return (
            <div className="row no-gutter">
                <div className="col-xs-offset-2 col-xs-8">
                    <AccountDebitsEditErrorStep accountId={accountId} />
                </div>
            </div>
        );
    }

    buildWizard() {
        const {
            immAccounts,
            immAccountDebitsEdit,
            immFlagBasedFeatures,
            match: { params: { accountId } },
            resetStep,
            setVisibleStep,
            setWillCancel,
            validateStep
        } = this.props;
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            resetStep,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };
        const immSteps = immAccountDebitsEdit.get('steps');
        const immAccount = immAccounts.get('byId').get(accountId);
        const firstStep = immSteps.get(0);
        const newAccountId = firstStep.get('newAccount') || '';
        const immNewAccount = immAccounts.getIn(['byId', newAccountId]);
        const accountHolder = immAccount.get('accountHolder');
        const accountInfo = immAccount.getIn(['catalogData', 'subtype']) + getLastNChars(immAccount.get('iban'));
        const alias = immAccount.get('isAliasUpdating') ? toCamelCase(immAccount.get('aliasTentative')) : toCamelCase(immAccount.get('alias'));
        const balance = formatAmountObject(immAccount.get('balance'));
        const balanceText = `${balance.amount} ${balance.currencySymbol}`;
        let newAccountHolder;
        let newAccountInfo;
        let newAlias;
        let newBalance;
        let newBalanceText;
        const showError = (firstStep.get('newAccountIsDirty') && !firstStep.get('valid')) || !!!newAccountId;
        if (immNewAccount) {
            newAccountHolder = immNewAccount.get('accountHolder');
            newAccountInfo = immNewAccount.get('catalogData').get('subtype') + getLastNChars(immNewAccount.get('iban'));
            newAlias = immNewAccount.get('alias');
            newBalance = formatAmountObject(immNewAccount.get('balance'));
            newBalanceText = `${newBalance.amount} ${newBalance.currencySymbol}`;
        }
        const stepsAmount = immSteps.size;
        const visibleStep = immAccountDebitsEdit.get('visibleStep');
        const immFinalButton = 'profile-modifyButton';
        const isLoading = immAccountDebitsEdit.getIn([accountId, 'isFetching']) || false;

        return (
            <section className="debits-edit-view__wizard">
                <Wizard
                    actions={actions}
                    fullWidth={true}
                    immSteps={immSteps}
                    stepsAmount={stepsAmount}
                    visibleStep={visibleStep}
                    showPreLeaveModal={true}
                >
                    <WizardStep
                        cancelButton={true}
                        isLoading={isLoading}
                        position="first"
                    >
                        <AccountDebitsEditStep1
                            accountId={accountId}
                            accountHolder={accountHolder}
                            accountInfo={accountInfo}
                            alias={alias}
                            balance={balanceText}
                            immAccounts={immAccounts}
                            isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                            newAccountId={newAccountId}
                            onAccountChange={this.handleAccountChange}
                            showError={showError}
                        />
                    </WizardStep>
                    <WizardStep
                        addLoadingBehaviour={true}
                        cancelButton={true}
                        immFinalButton={immFinalButton}
                        position="last"
                    >
                        <AccountDebitsEditStep2
                            accountHolder={accountHolder}
                            accountInfo={accountInfo}
                            alias={alias}
                            balance={balanceText}
                            immAccounts={immAccounts}
                            newAccountHolder={newAccountHolder}
                            newAccountInfo={newAccountInfo}
                            newAlias={newAlias}
                            newBalance={newBalanceText}
                            operationParams={this.getOperationParams()}
                        />
                    </WizardStep>
                </Wizard>
            </section>
        );
    }

    handleAccountChange(accountId) {
        this.props.setAccount(accountId);
    }

    handleCancel() {
        const { history, match: { params: { accountId } } } = this.props;
        history.push(`/myprofile/accounts/${accountId}/debits`);
    }

    handleFinish() {
        const {
            immAccountDebitsEdit,
            match: { params: { accountId } }
        } = this.props;

        const immSteps = immAccountDebitsEdit.get('steps');
        const firstStep = immSteps.get(0);
        const newAccountId = firstStep.get('newAccount') || '';


        this.props.postChange(accountId, newAccountId);
    }

    render() {
        const { match: { params: { accountId } }, immAccounts, immAccountDebitsEdit } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);
        const alias = immAccount.get('isAliasUpdating') ? toCamelCase(immAccount.get('aliasTentative')) : toCamelCase(immAccount.get('alias'));
        const allAccountsInactive = hasAllAccountsInactive(
            immAccounts.get('byOrder'),
            immAccounts.get('byId')
        );
        let content;
        if (allAccountsInactive) {
            content = (<InactiveAccountsError
                navigateToBackButtonText={'accounts'}
                navigateToBackButtonURL={'accounts'}
            />);
        }
        else if (immAccountDebitsEdit.get('submitSuccessful')) {
            content = this.buildSuccessful();
        } else if (!!immAccountDebitsEdit.getIn([accountId, 'error'])) {
            content = this.buildError();
        } else {
            content = this.buildWizard();
        }

        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/accounts'
            },
            {
                text: alias,
                url: `/myprofile/accounts/${accountId}/movements`
            },
            {
                text: formatText('breadcrumb-debits'),
                url: `/myprofile/accounts/${accountId}/debits`
            },
            {
                text: formatText('breadcrumb-debitsEdit'),
                url: ''
            }
        ];

        return (
            <OKLayout
                breadcrumb={mappingBreadcrumb}
                className="debits-edit-view"
                title={getFinalTitle('debitsEdit-header')}
                section="loansmortgages"
                contentPosition={NEGATIVE}
            >
                {content}
            </OKLayout>
        );
    }
}

AccountDebitsEditView.propTypes = {
    cancel: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAccountDebitsEdit: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    postChange: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetStep: PropTypes.func.isRequired,
    setOriginAccountId: PropTypes.func.isRequired,
    setAccount: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired
};

module.exports.constructor = AccountDebitsEditView;
module.exports.AccountDebitsEditView = connect(
    state => ({
        immAccounts: state.accounts,
        immAccountDebitsEdit: state.accountDebitsEdit,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }), {
    cancel: accountDebitsEditActions.cancel,
    postChange: accountDebitsEditActions.postChange,
    reset: accountDebitsEditActions.reset,
    resetStep: accountDebitsEditActions.resetStep,
    setOriginAccountId: accountDebitsEditActions.setOriginAccountId,
    setAccount: accountDebitsEditActions.setAccount,
    setVisibleStep: accountDebitsEditActions.setVisibleStep,
    setWillCancel: accountDebitsEditActions.setWillCancel,
    validateStep: accountDebitsEditActions.validateStep
})(withRouter(AccountDebitsEditView));
